///////////////////////////////////////////////////

import { ofType } from 'redux-observable';
import { EMPTY, merge, of } from 'rxjs';
import { debounceTime, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { secondaryMarketDlpOrderTabContentPersistRequested } from 'state/secondaryMarket/dlpOrder/form/dlpOrderForm.actions';
import type { EpicWithThunk } from 'state/state.common';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';

export function triggerDlpOrderTabContentPersistenceEpic(): EpicWithThunk {
  return (
    actions$,
    state$,
    {
      selectors: {
        fromSecondaryMarket: {
          dlpOrder: {
            form: { getDlpOrderTabContentToPersist },
          },
        },
      },
      scheduler,
    },
  ) => {
    const newForm$ = actions$.pipe(
      ofType('WORKSPACE_TAB_CREATED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketQuotes' && tabType === 'dlpProducts'),
      map(({ id }) => id),
    );
    const modifyForm$ = actions$.pipe(
      ofType('SECONDARY_MARKET_DLP_ORDER_FORM_FIELD_CHANGED'),
      debounceTime(3_000, scheduler),
      withLatestFrom(state$),
      filter(([{ tabId }, state]) => getWorkspaceType(state, tabId) === 'secondaryMarketQuotes'),
      map(([{ tabId }, _]) => tabId),
    );
    return merge(modifyForm$, newForm$).pipe(
      withLatestFrom(state$),
      mergeMap(([tabId, state]) => {
        const persistedTabContent = getDlpOrderTabContentToPersist(state, tabId);
        if (persistedTabContent === undefined) {
          return EMPTY;
        }
        return of(secondaryMarketDlpOrderTabContentPersistRequested(tabId, persistedTabContent));
      }),
    );
  };
}
